<template>
    <v-app>
        <Sidebar
            v-if="loggedIn"
            :drawer="drawer"
            @toggle-drawer="toggleDrawer"
        />
        <Toolbar
            :drawer="drawer"
            :main-loader="mainLoader"
            @open-change-password-dialog="openChangePasswordDialog"
            @toggle-drawer="toggleDrawer"
        />
        <Content />
        <Footer />

        <Snackbar />

        <v-overlay :value="circularLoader" color="black" opacity="0.2" z-index="500">
            <v-progress-circular
                indeterminate
                color="secondary"
                size="64"
                width="3"
            />
        </v-overlay>


        <v-overlay :value="mainLoader" color="black" opacity="0" z-index="500" />

        <ChangePasswordDialog
            :is-open="changePasswordDialog"
            @on-close="closeChangePasswordDialog"
        />
    </v-app>
</template>

<script>
import Toolbar from '@/components/Toolbar'
import Sidebar from '@/components/Sidebar'
import Content from '@/components/Content'
import Footer from '@/components/Footer'
import Snackbar from '@/components/Snackbar'
import ChangePasswordDialog from '@/views/User/ChangePasswordDialog'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'App',
    components: {
        Toolbar,
        Sidebar,
        Content,
        Footer,
        Snackbar,
        ChangePasswordDialog
    },
    data() {
        return {
            drawer: true,
            changePasswordDialog: false,
        }
    },
    computed: {
        mainLoader() {
            return this.$store.state.common.mainLoader
        },
        circularLoader() {
            return this.$store.state.common.circularLoader
        },
        loggedIn() {
            return this.$store.getters.loggedIn
        }
    },
    mounted() {
        this.$store.dispatch('getErrorCodes')
            .catch(error => {
                errorHandler(error)
            })
    },
    methods: {
        toggleDrawer(value) {
            this.drawer = value
        },
        openChangePasswordDialog() {
            this.changePasswordDialog = true
        },
        closeChangePasswordDialog() {
            this.changePasswordDialog = false
        }
    }
}
</script>
